import { render } from "./RelationshipColumnSettings.vue?vue&type=template&id=7e19f33c"
import script from "./RelationshipColumnSettings.vue?vue&type=script&lang=js"
export * from "./RelationshipColumnSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__